import React, { FC } from "react"
import { graphql } from "gatsby"
import xss from "xss"

import { LogosBlockFragmentFragment } from "@graphqlTypes"

import { generateConditionalClassName, oneLineHelpScout, preventSleepyBuddies } from "@utils"

import CustomerLogo from "@components/CustomerLogo/CustomerLogo"
import LpSection from "@components/lp/LpSection/LpSection"

import "./LogosBlock.scss"

const LogosBlock: FC<LogosBlockFragmentFragment> = ({
  contentful_id,
  logos,
  title = "More than 12,000 businesses delight their customers with Help Scout.",
  background,
  includeBackground,
  marginBottom,
  useDarkMode,
}) => {
  return (
    <LpSection
      className={generateConditionalClassName({
        LogosBlock: true,
        [`item-count--${Math.ceil((logos || []).length / 6) * 6}`]: true,
      })}
      background={background}
      includeBackground={includeBackground}
      marginBottom={marginBottom}
      uniqueId={contentful_id}
      useDarkMode={useDarkMode}
    >
      <div className="container">
        <div className="grid">
          {title && (
            <h2
              className="column column--2-12-L column--3-11-XL type--mono-M text-align--center margin-bottom--M"
              dangerouslySetInnerHTML={{
                __html: xss(oneLineHelpScout(preventSleepyBuddies(title))),
              }}
            />
          )}
          {logos && (
            <div className="LogosRows column column--3-11-M column--1-13-L">
              <div className="flex">
                {logos.slice(0, 6).map((node, i) => (
                  <div
                    className={
                      // 2 cols @ XS, 3 cols @ M, 6 cols @ L
                      `LogosBlock--Logo flex-item--2 flex-item--3-M flex-item--6-L`
                    }
                    key={node.companyName}
                  >
                    <CustomerLogo {...node} />
                    {logos[i + 6] && <CustomerLogo {...logos[i + 6]} />}
                    {logos[i + 12] && <CustomerLogo {...logos[i + 12]} />}
                  </div>
                ))}
              </div>

            </div>
          )}
        </div>
      </div>
    </LpSection>
  )
}

export const LogosBlockFragment = graphql`
  fragment LogosBlockFragment on ContentfulLpLogosBlock {
    contentful_id
    logos {
      ...CustomerLogoFragment
    }
    title
    background
    includeBackground
    marginBottom
    useDarkMode
  }
`

export default LogosBlock
